import React, { useEffect, useRef, useState } from 'react';
import './index.scss';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import { IssueStatus } from '@/utils/type';
import CompleteIssueModal from '@/components/CompleteIssueModal';
import { getClstag } from '@/utils/util';
import ReminderModal from '@/components/ReminderModal';
import { showMsg } from '@/utils/util';
import { HttpStatusCode } from '@/fetch/core/constant';
import IssueApi from '@/fetch/bussiness/issue';
const fetchApi = new IssueApi();
const CompleteIssue = (props: {
  vehicleName: string;
  closeDropdown: () => void;
}) => {
  const { list } = useSelector((state: RootState) => state.issue);
  const newCommon = useSelector((state: RootState) => state.newCommon);
  const [remindReportModal, setRemindReportModal] = useState(false);
  const { vehicleName } = props;
  const { issueStatus, issueNumber } =
    list?.find((workOrder: any) => {
      return workOrder.vehicleName === vehicleName;
    }) || {};
  const [open, setOpen] = useState(false);
  const usable = issueStatus === IssueStatus.PROCESS;
  const getCurrentIssueEventInfo = async () => {
    try {
      const res = await fetchApi.getIssueEvent({ issueNumber: issueNumber });
      if (res.code === HttpStatusCode.Success) {
        if (res.data.accidentProcessed) {
          setOpen(true);
        } else {
          setOpen(false);
          setRemindReportModal(true);
        }
        props.closeDropdown();
      } else {
        showMsg({
          msg: res.message,
          type: 'error',
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  return (
    <>
      <button
        className="issue-command-btn"
        disabled={!issueNumber || !usable}
        onClick={() => {
          if (!issueNumber) {
            return;
          }
          usable && getCurrentIssueEventInfo();
        }}
        clstag={
          usable
            ? getClstag(newCommon.cockpitMode, 'SinglePage_CompleteIssue')
            : ''
        }
      >
        结单
      </button>
      <CompleteIssueModal
        open={open}
        setOpen={setOpen}
        issueNumber={issueNumber}
        issueStatus={issueStatus}
        vehicleName={vehicleName}
      />
      <ReminderModal
        vehicleName={vehicleName}
        remindReportModal={remindReportModal}
        setRemindReportModal={setRemindReportModal}
      />
    </>
  );
};

export default React.memo(CompleteIssue);
